import { KeyValueDiffers } from '@angular/core';
import {  FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { FormErrors } from "../login/auth.service";

import { BadFile } from './badfile'

const ageGroups: AgeGroup[] = [
  {title: "0-11", from: 0, to: 11, selected: false},
  {title: "12-17", from: 12, to: 17, selected: false},
  {title: "18-24", from: 18, to: 24, selected: false},
  {title: "25-34", from: 25, to: 34, selected: false},
  {title: "35-44", from: 35, to: 44, selected: false},
  {title: "45-54", from: 45, to: 54, selected: false},
  {title: "55-64", from: 55, to: 64, selected: false},
  {title: "65-74", from: 65, to: 74, selected: false},
  {title: "75+", from: 75, to: 100, selected: false},
]

export class TargetAd {
  title: string;

  public uploader: FileUploader;
  public images: number = 0;
  public videos: number = 0;

  public errors: FormErrors = new FormErrors;
  public badFiles: Array<BadFile> = [];

  public currentPreview: number = 0;
  private previewPaused: boolean = false;
  private cycleTimer: any;

  differ: any;

  public maleAgeGroups: AgeGroup[] = [];
  public femaleAgeGroups: AgeGroup[] = [];

  public slotSelectionMode: boolean = true;

  constructor(private differs: KeyValueDiffers, private uploaderSettings: any) {
    ageGroups.forEach(val => {
      this.maleAgeGroups.push(Object.assign({}, val));
      this.femaleAgeGroups.push(Object.assign({}, val));
    });

    this.uploader = new FileUploader(uploaderSettings);

    var instance = this;
    this.uploader.onWhenAddingFileFailed = function(item, filter, options) {
      instance.badFiles.push(new BadFile(item, filter));
    };

    this.uploader.onAfterAddingFile = function(fileItem) {
      if (/video\/*/.test(fileItem.file.type)) {
        instance.uploader.removeFromQueue(fileItem);
        var obj = document.createElement('video');
        obj.preload = 'metadata';

        obj.onloadedmetadata = function() {
          if (Math.floor(obj.duration) > uploaderSettings.duration) {
            instance.badFiles.push(new BadFile(fileItem.file, {name: "duration"}));
          } else {
            instance.uploader.queue.push(fileItem);
          }
        };
        obj.src = URL.createObjectURL(fileItem._file);    
      }
    };

    this.differ = differs.find({}).create(null);
  }

  warning() {
    return !this.errors.isEmpty() && (this.emptyTitle() || this.emptyFiles() || this.emptyTargetGroup() || this.title.trim().toLowerCase() == "default")
  }

  emptyFiles() {
    return this.uploader.queue.length == 0
  }

  emptyTitle() {
    return !this.title || (this.title && this.title.replace(/\s/g, '') == '')
  }

  emptyTargetGroup() {
    var empty: boolean = true;

    this.maleAgeGroups.forEach((element, ind) => {
      if (element.selected || this.femaleAgeGroups[ind].selected) {
        empty = false;
      }
    });

    return empty;
  }

  public startPreview() {
      if (this.previewPaused) return;

      if (this.cycleTimer) {
        clearInterval(this.cycleTimer);
        this.currentPreview = 0;
      }
      let instance = this;
      this.cycleTimer = setInterval(function(){
        instance.currentPreview = (instance.currentPreview+1)%instance.uploader.queue.length;
      }, 2000);
  }

  public previewUnavailable() {
      if (this.cycleTimer) {
          clearInterval(this.cycleTimer);
          this.currentPreview = 0;
      }
  }

  onMouseOverAgeGroup($event, slot, not_available) {
    if (($event.buttons == undefined? $event.which : $event.buttons) && !not_available) {
      slot.selected = this.slotSelectionMode;
    }
  }

  onMouseDownAgeGroup($event, slot, not_available) {
    if (!not_available) {
      if (($event.buttons == undefined? $event.which : $event.buttons)) {
        this.toggleSlot(slot, not_available);
        this.slotSelectionMode = slot.selected == true;
      }
    }
  }

  public toggleSlot(slot: any, not_available) {
    if (!not_available) {
      slot.selected = !slot.selected;
    }
  }
}

class AgeGroup {
  title: string;
  from: number;
  to: number;
  selected: boolean = false;
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/upload/target-ad.component.ts